import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
interface OrderBumpProps {
  image: string;
  badge: string;
  title: string;
  description: string;
  regularPrice?: string;
  price: string;
  checked: boolean;
  onToggle: () => void;
}
export function OrderBump({
  image,
  badge,
  title,
  description,
  regularPrice,
  price,
  checked,
  onToggle
}: OrderBumpProps) {
  return <motion.button type="button" onClick={onToggle} whileHover={{
    y: -2
  }} whileTap={{
    y: 0
  }} className={`w-full text-left rounded-2xl border-2 border-dashed transition-all overflow-hidden ${checked ? 'border-sage-700 bg-sage-50 shadow-md' : 'border-yellow-500/60 bg-yellow-50/50 hover:border-yellow-600 pulse-bump'}`} aria-pressed={checked} data-id="element-374">
      {/* Top ribbon with shimmer */}
      <div className={`text-center py-2 px-4 text-xs md:text-sm font-bold tracking-widest uppercase transition-colors ${checked ? 'bg-sage-700 text-cream' : 'bg-yellow-400 text-charcoal shimmer-ribbon'}`} data-id="element-375">
        ⚡ Altamente Recomendado
      </div>

      <div className="p-4 md:p-5 flex flex-col sm:flex-row gap-4 items-start" data-id="element-376">
        {/* Checkbox */}
        <div className="flex-shrink-0 pt-1" data-id="element-377">
          <div className={`w-6 h-6 rounded-md border-2 flex items-center justify-center transition-all ${checked ? 'bg-sage-700 border-sage-700' : 'bg-white border-charcoal/30'}`} data-id="element-378">
            {checked && <Check size={16} className="text-cream" strokeWidth={3} data-id="element-379" />}
          </div>
        </div>

        {/* Image */}
        <div className="flex-shrink-0 w-24 h-24 rounded-xl overflow-hidden bg-cream-dark flex items-center justify-center" data-id="element-380">
          <img src={image} alt={title} className="w-full h-full object-cover" data-id="element-381" />
        </div>

        {/* Content */}
        <div className="flex-1 min-w-0" data-id="element-382">
          <h4 className="font-bold text-charcoal text-base md:text-lg leading-tight mb-1" data-id="element-383">
            ¡SÍ! Quiero añadir: {title}
          </h4>
          <p className="text-sm text-charcoal-light leading-relaxed mb-3" data-id="element-384">
            {description}
          </p>
          <div className="flex items-baseline gap-2 flex-wrap" data-id="element-385">
            {regularPrice && <span className="text-sm text-charcoal-light/60 line-through" data-id="element-386">
                Precio regular {regularPrice}
              </span>}
            <span className="text-lg font-bold text-sage-700" data-id="element-387">
              Hoy solo {price}
            </span>
          </div>
        </div>
      </div>
    </motion.button>;
}